import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from '../auth.service';

@Component({
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  constructor(private _router: Router, private _authService: AuthService) {}

  ngOnInit() {
    this._authService.logout();
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/logout/logout.component.ts